import { withStyles } from "@material-ui/core";
import React from "react";
import Header from "./Header";

const styles = (theme) => ({
  message: {
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
  },
});

const ErrorContainer = ({ label, message, classes }) => (
  <>
    <Header label={label} variant="error" />
    <div className={classes.message}>{message}</div>
  </>
);

export default withStyles(styles)(ErrorContainer);
